import styled from 'styled-components'

export const ColumnWrapper=styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
export const RowWrapper=styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`
export const PaddingWrapper = styled.div`
  padding: 36px;
`